import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var StringText = props => {
  var {
    Str: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Str');
  return null;
};
StringText.displayName = 'JVR.StringText';